import moment from "moment"

export const toStringYearFirst = (date: Date): string => {
  return moment(date).format("YYYY-MM-DD")
}

export const toOnlyDateString = (date: Date): string => {
  return moment(date).format("DD-MM-YYYY")
}

export const dayBefore = (date: Date): Date => {
  console.log(date)
  const result = new Date(date)
  result.setDate(date.getDate() - 1)
  return result
}
export function getWithAddedDay(date: Date): Date {
  var newDate = new Date(date.getTime())
  newDate.setDate(newDate.getDate() + 1)
  return newDate
}

export function getWithAddedMonths(date: Date, months: number): Date {
  var newDate = new Date(date.getTime())
  newDate.setMonth(newDate.getMonth() + months)
  return newDate
}

export function getBeginOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function serializeDate(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function pad(n: number): string {
  return n < 10 ? "0" + n : n.toString()
}

export function getDurationFromYears(years: number) {
  const months = Math.round(years * 12)
  const parts: string[] = []

  if (months >= 12) parts.push(`${Math.floor(months / 12)} jaar`)
  const rest = months % 12
  if (rest === 1) parts.push("1 maand")
  else if (rest > 1) parts.push(`${rest} maanden`)
  else parts.push("Minder dan een maand")

  return parts.join(" en ")
}